import request from '../utils/request';

export default function createHeapMiddleware() {
  const requestURL = `${window.location.origin}/dava/api/analytics`;
  let frLeid;
  let nmuid;

  return (next) => (action) => {
    if (action && action.users) {
      frLeid = action.users.fr_leid;
      nmuid = action.users.nmuid;
    }

    if (action.token && nmuid && frLeid) {
      const options = {
        method: 'POST',
        json: true,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: `${action.type}`,
          user: `${frLeid}`,
          properties: {
            nmuid: `${nmuid}`,
            token: `${action.token}`,
          },
        }),
      };
      request(requestURL, options);
    }

    // Call the next dispatch method in the middleware chain.
    const returnValue = next(action);

    // This will return the action itself
    return returnValue;
  };
}
